import { render, staticRenderFns } from "./sendNotify.vue?vue&type=template&id=43cfb25a&scoped=true"
import script from "./sendNotify.vue?vue&type=script&lang=js"
export * from "./sendNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cfb25a",
  null
  
)

export default component.exports